import styled, { css } from 'styled-components';

export const StyledPlaceholder = styled.div(({ verticalPadding }: { verticalPadding: number }) => {
  return css`
    background: white;
    border: 0.0625rem black dashed;
    text-align: center;
    min-height: 100%;
    padding: ${`${verticalPadding}rem`} 0;
  `;
});
